import {useEffect, useRef, useState} from "react";
import Swal from "sweetalert2";
import {toast} from "react-toastify";
import config from "../../config/apiService.json";
import fetchData from "../../utils/fetchData";
import {fileTypePdfOrNot} from "../../utils/fileTypeValidityCheckService";
import {deleteMethod, patchMethod, postMethod} from "../../utils/httpServices";

const UseActsRulesAndOrders = () => {
  const modalCloseIconButton = useRef();
  const fileInputRef = useRef(null);
  const titleInputRef = useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState(0);
  const [pdfFile, setPdfFile] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [demoObj, setDemoObj] = useState({titleEn: "", file: ""});
  const [modalPdfFile, setModalPdfFile] = useState(null);
  const pageSize = 10;
  const {actRuleOrders: actRuleOrdersApiEndPoint, administrative} = config;

  const getData = async () => {
    const response = await fetchData(`${actRuleOrdersApiEndPoint}?currentPage=${activePage}&recordPerPage=${pageSize}`);
    const {actRuleOrders} = response;
    if (actRuleOrders.length === 0) setHasMore(false);
    setData([...data, ...actRuleOrders]);
    const newActivePage = activePage + 1;
    setActivePage(newActivePage);
  };

  useEffect(() => {
    getData();
    setLoading(false);
  }, []);

  const handleTittleChange = (e, id) => {
    const modifiedData = data.map(d => {
      if (d.id === id) {
        d.titleEn = e.target.value;
      }
      return d;
    });
    setData(modifiedData);
    if (e.target.value.length >= 99) toast.warn("Maximum is 100 characters!");
  }

  const handleFileUpload = (e, id) => {
    const file = e.target.files[0];
    if (file) {
      const fileTypePdfOrNotResult = fileTypePdfOrNot(file);
      if (fileTypePdfOrNotResult) {
        const modifiedData = data.map(d => {
          if (d.id === id) {
            d.fileTag = file.name;
          }
          return d;
        });
        setData(modifiedData);
        setPdfFile(file);
      }
    }
  }

  const handleUpdate = async (id) => {
    let updatedData = data.filter(d => d.id === id);
    updatedData = updatedData[0];

    const formData = new FormData();
    pdfFile && formData.append('file', pdfFile);
    formData.append('titleEn', updatedData.titleEn);

    try {
      const response = await patchMethod(`${administrative.actRuleOrders}/${id}`, formData);
      if (response) {
        toast.success("ACTs, Rules & Orders Updated!");
        getData();
        setPdfFile(null);

      }
    } catch (ex) {
      toast.error(ex.response.data);
    }
  }

  const handleDelete = async (id) => {
    try {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#354e80',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteMethod(`${administrative.actRuleOrders}/${id}`);
          if (response) {
            let updatedData = data.filter(d => d.id !== id);
            setData(updatedData);
            Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
            )
          }
        }
      });
    } catch (ex) {
      toast.error(ex.response.data);
    }
  }

  // Add ACTs, Rules & Orders
  const handleModalTittleChange = (e) => {
    setDemoObj({
      ...demoObj,
      titleEn: e.target.value
    });
    if (e.target.value.length >= 99) toast.warn("Maximum is 100 characters!");
  }

  const handleModalFileUpload = (e) => {
    let file = e.target.files[0];
    if (file) {
      const fileTypePdfOrNotResult = fileTypePdfOrNot(file);
      if (fileTypePdfOrNotResult) {
        setModalPdfFile(file);
        setDemoObj({
          ...demoObj,
          file: file.name
        });
      }
    }
  }

  const handleAdd = async () => {
    try {
      const formData = new FormData();
      modalPdfFile && formData.append("file", modalPdfFile);
      formData.append("titleEn", demoObj.titleEn);

      const response = await postMethod(`${administrative.actRuleOrders}`, formData);
      if (response) {
        toast.success("Acts Rules Orders Added!");
        let updatedData = data;
        updatedData = [response, ...updatedData];
        setData(updatedData);
        modalCloseIconButton.current.click();
      }
    } catch (ex) {
      toast.error(ex.response.data);
    }
  }

  const handleCloseModal = () => {
    fileInputRef.current.value = "";
    titleInputRef.current.value = "";
    setModalPdfFile(null);
    setDemoObj({titleEn: "", file: ""});
  };

  return {
    modalCloseIconButton,
    handleModalTittleChange,
    demoObj,
    handleModalFileUpload,
    handleAdd,
    handleUpdate,
    isLoading,
    data,
    getData,
    hasMore,
    handleDelete,
    handleTittleChange,
    handleFileUpload,
    handleCloseModal,
    fileInputRef,
    titleInputRef
  }
};

export default UseActsRulesAndOrders;
